import React from "react";
import BootstrapCard from 'shared/components/bootstrapCard/BootstrapCard';
import PropTypes from 'prop-types';
import { MONTHS } from 'shared/components/monthPicker/helpers/monthPickerConstants';
import { formatCurrency } from "shared/helpers/dataFormatHelper";

class TransactionSummaryContainer extends React.Component{
  componentDidMount(){
    this.props.transactionSummaryActions.fetchTransactionSummary();
  }

  render(){
    const date = new Date();
    const {taxObligation, taxPaid} = this.props.transactions;

    return(
      <BootstrapCard 
        title={ `Transaction Summary - ${MONTHS[date.getMonth()]} ${date.getFullYear()}` }
        height={ 380 }
        margin={ '12px 0 0 10px' }
        padding={ 0 }
      >
        <div className="transaction-summary-container">
          <ul className="transaction-summary-container__list">
            <li><div><span>Tax Obligations</span></div><div>{formatCurrency(taxObligation)}</div></li>
            <li><div><span>Vendor Charged Tax</span></div><div>{formatCurrency(taxPaid)}</div></li>
            <li><div><span>Total Variance</span></div><div>{formatCurrency(taxObligation - taxPaid)}</div></li>
          </ul>
        </div>
      </BootstrapCard>
    );
  }
}

TransactionSummaryContainer.propTypes = {
  transactionSummaryActions: PropTypes.shape({
    fetchTransactionSummary: PropTypes.func
  }).isRequired,
  transactions: PropTypes.object.isRequired
};


export default TransactionSummaryContainer;



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/transactionSummary/TransactionSummaryContainer.js